/* eslint-disable no-unused-vars */
import React from "react";
import { Layout, Row, Col, Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import useWindowDimensions from "../../helper/viewport";

const Navbar = () => {
  const { Header } = Layout;
  const history = useHistory();
  const { width } = useWindowDimensions();

  return (
    <Header
      style={{
        backgroundColor: "#1B6FBA",
        height: 100,
      }}
    >
      <Row
        justify="space-between"
        align="middle"
        style={{
          padding: "12px 0px 0px 0px",
        }}
      >
        <Col>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              lineHeight: "normal",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/Logo.png`}
              alt="logo"
              style={{
                height: 60,
              }}
            />
            {width >= 570 ? (
              <div
                className="text-default"
                style={{
                  marginLeft: 16,
                  whiteSpace: "normal",
                  color: "#fff",
                }}
              >
                <div className="text-bold">KEMENTERIAN AGAMA</div>
                <div>REPUBLIK INDONESIA</div>
              </div>
            ) : null}
          </div>
        </Col>
        {width >= 1100 &&
        history.location.pathname.includes("indeks-karakter-siswa") ? (
          <Col
            className="text-header"
            style={{
              textAlign: "center",
              color: "#fff",
              lineHeight: 1.5,
            }}
          >
            <div>Indeks Karakter Siswa</div>
            <div>Jenjang Pendidikan Menengah</div>
          </Col>
        ) : null}
        {width >= 1100 &&
        history.location.pathname.includes("pendidikan-madrasah") ? (
          <Col
            className="text-header"
            style={{
              textAlign: "center",
              color: "#fff",
              lineHeight: 1.5,
            }}
          >
            <div>Pendidikan Madrasah</div>
          </Col>
        ) : null}
        {width >= 1100 &&
        history.location.pathname.includes("pondok-pesantren") ? (
          <Col
            className="text-header"
            style={{
              textAlign: "center",
              color: "#fff",
              lineHeight: 1.5,
            }}
          >
            <div>Sebaran Pondok Pesantren </div>
            <div>Hasil Pemetaan Tahun 2020 dan 2021</div>
          </Col>
        ) : null}
        {width >= 1100 &&
        history.location.pathname.includes("pendidikan-keagamaan") ? (
          <Col
            className="text-header"
            style={{
              textAlign: "center",
              color: "#fff",
              lineHeight: 1.5,
            }}
          >
            <div>Peta Pendidikan Keagamaan</div>
            <div>Kristen, Katolik, Hindu, Buddha, dan Khonghucu</div>
          </Col>
        ) : null}
        <Col>
          <Button
            shape="round"
            size="large"
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FEC845",
            }}
            onClick={() => {
              history.push("/");
            }}
          >
            <HomeOutlined
              style={{
                fontSize: 24,
              }}
            />
            <span className="text-bold">Halaman Utama</span>
          </Button>
        </Col>
      </Row>
    </Header>
  );
};

export default Navbar;
